

































import traceQuery from '~/queries/trace.gql'

export default

	data: ->
		loaded: false
		sectionData: {}
		config:
			slidesPerPage: 1
			showDots: false
			showArrows: true

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'phenols'
				slug: 'phenols'

		@loaded = true

